'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n'], ['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  margin-bottom: 10px;\n'], ['\n  display: inline-block;\n  margin-bottom: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nitroBadge = require('../nitro-badge');

var _nitroBadge2 = _interopRequireDefault(_nitroBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BadgeList = _styledComponents2.default.ul(_templateObject);

BadgeList.displayName = 'BadgeList';
var Badge = _styledComponents2.default.li(_templateObject2);

Badge.displayName = 'Badge';

var NitroBadgeSelect = function (_Component) {
  _inherits(NitroBadgeSelect, _Component);

  function NitroBadgeSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NitroBadgeSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NitroBadgeSelect.__proto__ || Object.getPrototypeOf(NitroBadgeSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleOptionSelect = function (checked, value) {
      var values = [].concat(_toConsumableArray(_this.props.value));

      if (values.length === 1 && checked && _this.props.mandatory) {
        return;
      }

      if (checked) {
        values = values.filter(function (v) {
          return v !== value;
        });
      } else {
        var options = _this.props.options.filter(function (option) {
          return values.includes(option.value) || option.value === value;
        });
        values = options.map(function (option) {
          return option.value;
        });
      }

      _this.props.action({ value: values });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NitroBadgeSelect, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          value = _props.value,
          options = _props.options;


      return _react2.default.createElement(
        BadgeList,
        { className: className },
        options.map(function (option, index) {
          var checked = value.includes(option.value);
          var variant = checked ? 'secondary' : '';
          return _react2.default.createElement(
            Badge,
            { key: index },
            _react2.default.createElement(_nitroBadge2.default, {
              minWidth: 60,
              variant: variant,
              label: option.label,
              size: 16,
              action: function action() {
                return _this2.handleOptionSelect(checked, option.value);
              }
            })
          );
        })
      );
    }
  }, {
    key: 'mandatory',
    get: function get() {
      var _props2 = this.props,
          mandatory = _props2.mandatory,
          value = _props2.value;

      return mandatory && value.length === 1;
    }
  }]);

  return NitroBadgeSelect;
}(_react.Component);

NitroBadgeSelect.propTypes = {
  action: _propTypes2.default.func,
  options: _propTypes2.default.array,
  value: _propTypes2.default.array,
  mandatory: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.default = NitroBadgeSelect;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-badge-select/NitroBadgeSelect.js
// module id = 2884
// module chunks = 4